import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { LoggerModule } from 'ngx-logger';
import { environment } from '../environments/environment';
import { ModalModule } from 'ngx-bootstrap/modal';
import { sessionInterceptor } from './sessionInterceptor';
import { logInterceptor } from './logInterceptor';
import { FXAuthService } from './services/fx-auth.service';
import { ENVIRONMENT } from '@company-box/models';
import { AUTH_SVC, CheckoutService as SharedCheckoutService } from '@company-box/services';
import { CheckoutService as FedexCheckoutService } from './services/checkout.service';
import { AnalyticsService } from './services/analytics.service';


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([sessionInterceptor, logInterceptor])),
    importProvidersFrom([
      BrowserAnimationsModule,
      LoggerModule.forRoot({
        serverLoggingUrl: environment.logger.serverLoggingUrl,
        level: environment.logger.logLevel,
        serverLogLevel: environment.logger.serverLogLevel,
      }),
      ModalModule.forRoot(),
    ]),
    provideAnimations(),
    provideAppInitializer(() => inject(AnalyticsService).init()),
    { provide: ENVIRONMENT, useValue: environment },
    { provide: AUTH_SVC, useClass: FXAuthService },
    { provide: SharedCheckoutService, useClass: FedexCheckoutService },
  ],
};
